@if (!selectionInGroup) {
  @if (group.type === 'admin') {
    <rt-avatar [imageSrc]="group.avatarUrl" type="image" size="small-x" margin-lr-small-xx />
  }
  @if (group.type === 'job_status') {
    <rt-offer-status-indicator
      [offerStatus]="{ kind: 'job', status: group.id }"
      margin-left-small-xx
      margin-right-small-x
    />
  }
}
@if (selectionInGroup) {
  <rt-checkbox
    [checked]="selectionInGroup === 'all'"
    [indeterminateState]="selectionInGroup === 'indeterminate'"
    (click)="select.emit(group)"
  />
}
<rt-default-group-header [group]="group" />
